import { api } from 'api/index';
import { getPlans, getPlansWithDiscount } from 'api/service';
import i18next from 'i18next';
import { showToast } from 'states/actions/toast';
import {
  CLEAR_DISCOUNT_ERROR,
  FETCH_PLANS,
  SET_DISCOUNT_ERROR,
  SET_DISCOUNT_LOADING,
  SET_PALNS_AND_DISCOUNT,
  SET_PALNS_WITHOUT_DISCOUNT,
  UPGRADE_MODAL_CLOSE,
  UPGRADE_MODAL_OPEN,
} from '../constants';

export const getPlansAction = (dispatch) => async () => {
  getPlans((success, data) => {
    if (success) {
      dispatch({
        type: FETCH_PLANS,
        payload: data.data || [],
      });
    } else {
      dispatch({ type: FETCH_PLANS, payload: [] });
    }
  });
};
export const getPlansWithoutDiscountAction = (dispatch) => async () => {
  setDiscountLoading(dispatch)(true);
  getPlans((success, data) => {
    if (success) {
      dispatch({
        type: SET_PALNS_WITHOUT_DISCOUNT,
        payload: data.data || [],
      });
    } else {
      dispatch({ type: SET_PALNS_WITHOUT_DISCOUNT, payload: [] });
    }
  });
};

export const getPlansWithDiscountAction = (dispatch) => async (discountCode, afterSuccess) => {
  setDiscountLoading(dispatch)(true);
  getPlansWithDiscount({ discountCode }, (success, data) => {
    if (success) {
      afterSuccess && afterSuccess();
      dispatch({
        type: SET_PALNS_AND_DISCOUNT,
        payload: data.data,
      });
    } else {
      if (data.message_key) {
        dispatch({
          type: SET_DISCOUNT_ERROR,
          payload: i18next.t(data.message_key),
        });
      } else {
        showToast(dispatch)(i18next.t('msg_st_went_wrong'), {
          error: true,
        });
        setDiscountLoading(dispatch)(false);
      }
    }
  });
};
export const setDiscountLoading = (dispatch) => async (loading) => {
  dispatch({
    type: SET_DISCOUNT_LOADING,
    payload: loading,
  });
};
export const clearDiscountError = (dispatch) => async () => {
  dispatch({
    type: CLEAR_DISCOUNT_ERROR,
  });
};
export const upgardeModalOpen = (dispatch) => async (permissionKey, gaEventTrackingInfo) => {
  dispatch({
    type: UPGRADE_MODAL_OPEN,
    payload: {
      permissionKey,
      gaEventTrackingInfo,
      openedAt: Date.now(),
    },
  });
};
export const upgardeModalClose = (dispatch) => async () => {
  dispatch({
    type: UPGRADE_MODAL_CLOSE,
  });
};

export const SET_PRICING_PLANS = 'SET_PRICING_PLANS';

export const fetchPricingPlans = (dispatch) => async () => {
  try {
    const plansUi = await api.getPlansAdapted();
    dispatch({ type: SET_PRICING_PLANS, payload: plansUi });
  } catch (e) {
    dispatch({ type: SET_PRICING_PLANS, payload: [] });
  }
};
